import { useI18n } from "../../utils/lni18n";
import Singlequestion from "./QAedit/SingleQuestion";
import { BaseTestDataDTO } from "./DomainModels";
import React, { useCallback, useEffect, useState } from "react";
import { TestType } from "../domain/TestTypeInfoDTO";
import * as Yup from 'yup';
import { yupResolver } from "@hookform/resolvers/yup";
import { Controller, useForm } from "react-hook-form";
import HtmlTextEditor from "src/components/TextEditor/HtmlTextEditor";
import testService from "./TestService";
import { ErrorMessage } from "@hookform/error-message";
import MultipleQuestion from "./QAedit/MultipleQuestion";
import FileTest from "./FileTest/FileTest";
import SelfAssessement from "./QAedit/SelfAssessement";
import SimpleSelfAssessement from "./QAedit/SimpleSelfAssessement";
import MCTest from "./MCTest/MCTest";
import DrawingTest from "./DrawingTest/DrawingTest";
import { useLocation } from "react-router-dom";

const EditTestForm = (props: { data: BaseTestDataDTO, onNameChange: (name: string) => void }) => {

    const { languageService: t } = useI18n();
    const { data, onNameChange } = props;
    const { state } = useLocation();


    const [thisTest, setThisTest] = useState(data);

    let editor: any | undefined = undefined;

    const validationSchema = React.useMemo(() => Yup.object({
        Name: Yup.string().required(t.getText('required_field')),
        Meta: Yup.string().notRequired(),
        TestData: Yup.mixed().required(),
        Instructions: Yup.string().notRequired(),
        PartID: Yup.string().required(),
        TestId: Yup.string().required(),
        Type: Yup.number().required()

    }), [t]);

    const { control, watch, register, formState: { errors }, setValue } = useForm({
        defaultValues: thisTest,
        resolver: yupResolver(validationSchema),
        mode: "onChange"
    });


    useEffect(() => {
        setValue("Name", data.Name);
    }, [data.Name, setValue]);

    const setAllData = useCallback((value: any) => {
        setThisTest(prev => {
            const newData: BaseTestDataDTO = { ...prev, ...value };
            testService.testChanged(newData);
            return newData;
        });
        if (value.Name !== undefined) {
            onNameChange(value.Name);
        }
    }, [onNameChange]);
    

    React.useEffect(() => {
        const subscription = watch((value) => {
            setAllData(value)
        })
        return () => {
            subscription.unsubscribe();
        }
    }, [watch, setAllData])

    const setCustomData = (value: any) => {
        setValue( "TestData", value, { shouldValidate: true, shouldDirty: true } );
    }

    switch (data.Type) {

        case TestType.drawingtest:
            editor = <DrawingTest data={data} readOnly={state?.readOnly} onChange={d => setCustomData( d )} />
            break;

        case TestType.multiplechoice:
        case TestType.multiplechoice2:
            editor = <MCTest readOnly={state?.readOnly} data={data} onChange={d => setCustomData( d )} />
            break;

        case TestType.multiplequestion:
            editor = <MultipleQuestion data={data} onChange={d => setCustomData( d )} />
            break;

        case TestType.selfassessement:
            editor = <SelfAssessement data={data} onChange={d => setCustomData( d )} />
            break;

        case TestType.simpleselfassessement:
            editor = <SimpleSelfAssessement data={data} onChange={d => setCustomData( d )} />
            break;

        case TestType.fileupload:
            editor = <FileTest readOnly={state?.readOnly} data={data} onChange={d => setCustomData( d )} />
            break;

        case TestType.singlequestion:
        case TestType.simplyreply:
            editor = <Controller
                control={control}
                name="TestData"

                render={({ field: { onChange, value } }) => (
                    <Singlequestion data={data} value={value || ""} onChange={onChange} />
                )}
            />

            break;
    }

    return (
        <div key={data.TestId}>
            <div className="mb-5">
                <div className="alert alert-light px-5 pt-5 pb-5">
                    <div className="row">
                        <div className="col-lg-6">
                            <span className="fw-bold">
                                {t.getText("name")}
                            </span>
                            <ErrorMessage errors={errors} name="Name" render={({ message }) => <span className="ms-4 text-danger small fw-bold">{message}</span>} />
                            <input disabled={state?.readOnly} {...register("Name")} className="form-control" type="text" />

                        </div>
                    </div>

                    <div className="row ">
                        <div className="col-lg-6 mb-3 mb-lg-0 mt-5 d-flex flex-col" >
                            <div className="mt-auto">
                                <label className="fw-bold preserve-white">
                                    {t.getText("extra.instructions.to.students")}
                                </label>
                                <Controller
                                    control={control}
                                    name="Instructions"

                                    render={({ field: { onChange, value } }) => (
                                        <HtmlTextEditor readOnly={state?.readOnly} onChange={onChange} value={value || undefined} initialValue={data.Instructions || undefined} name="Instructions"  ></HtmlTextEditor>
                                    )}
                                />
                            </div>

                        </div>
                        <div className="col-lg-6 mt-5 d-flex flex-col">
                            <div className="mt-auto">
                                <label className="fw-bold preserve-white">
                                    {t.getText("guidelines")}
                                </label>
                                <Controller
                                    control={control}
                                    name="Meta"

                                    render={({ field: { onChange, value } }) => (
                                        <HtmlTextEditor readOnly={state?.readOnly} onChange={onChange} value={value || undefined} initialValue={data.Meta || undefined} name="Meta"  ></HtmlTextEditor>
                                    )}
                                />
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            {editor}
        </div>
    )

}

export default EditTestForm;

